import { Component, OnInit, ViewChild, Input, Injectable, Inject } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountStatusService } from './../../services/account-status/account-status.service';
import { GeneralService } from './../../services/admin/general.service';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { ENPOINT } from './../../services/endpoint';
import { TranslateService } from '@ngx-translate/core';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';

const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};

@Injectable()
export class I18n {
  lang; language;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    // console.log(this.storage.get('LOCAL_STORAGE'));
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }


  }
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}


@Component({
  selector: 'app-accountstatus',
  templateUrl: './account-status.component.html',
  providers: [GeneralService, AccountStatusService, CatalogsService,
    I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class AccountStatusComponent implements OnInit {
  @ViewChild('mydatatable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  private basePath;
  public user: User;
  rows: any = [];
  selected = [];
  facturas;
  rol;
  usuario;
  rfc;
  proveedores;
  proveedorFilter;
  folioi = "";
  foliof = "";
  serie = "";
  sociedad = "";
  pedido = "";
  doc_contable = "";
  fechaInicial;
  fechaFinal;
  fechaBusquedaFinal;
  busyBusqueda: boolean = false;
  mostarxml = false;
  diasTranscurridos;
  loadingExcel = false;

  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();

  sociedades = [];
  sociedadesBase = []
  sociedadFilter;
  sociedadesinput$ = new Subject<string>();

  fechasValidas: boolean = false;
  toastMessage;
  toastRangoFechasValido;
  toastCamposObligatorios;
  toast90dias;

  fechaHoy;
  fechaMin;
  fechaMax;

  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });

  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private storageService: StorageService,
    private catalogs: CatalogsService,
    private modalService: NgbModal,
    private accountStatus: AccountStatusService,
    private toasterService: ToasterService
  ) {

    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.especificarRangoFechas').subscribe(
      text => {
        this.toastMessage = text;
      });

    this.translate.get('texto.rangoFechasValido').subscribe(
      text => {
        this.toastRangoFechasValido = text;
      });

    this.translate.get('texto.edoCtaCamposObligatorios').subscribe(
      text => {
        this.toastCamposObligatorios = text;
      });

    this.translate.get('texto.rangoFechas90').subscribe(
      text => {
        this.toast90dias = text;
      });


    this.basePath = ENPOINT.url;
    this.getProveedores();
    this.getSociedades();
    //  fecha = new Date();

  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.modulo();
    this.rol = this.user.rol.id;
    this.usuario = this.user.nombre;
    this.rfc = this.user.rfc;
    //  this.sociedad = this.user.sociedad;
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Estado de cuenta').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  onDateSelect(e) {
    (<HTMLInputElement>document.getElementById('fechaf')).value = null;
    this.fechaBusquedaFinal = null;
  }

  fechaInicio(fechaiOpt) {
    // console.log(fechaiOpt);
  }

  getProveedores() {
    
    this.proveedores$ = concat(of([]),
      this.proveedorinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        
        tap(() => this.proveedoresLoading = true),
        switchMap(term =>
          this.catalogs.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoading = false)
          ))
      )
    );
  }

  search(){
    this.sociedades = []
    if (this.sociedadFilter && this.sociedadFilter !='') {

      let value = this.sociedadFilter.toLowerCase()
      
      const data = this.sociedadesBase.filter(
        row => row.sociedad.toLowerCase().includes(value));
      this.sociedades = data

    }else{
      this.sociedades = this.sociedadesBase
    }
    
    setTimeout(() => {
      this.sociedades = this.sociedades

    }, 100);
    
  }

  getSociedades() {
    this.catalogs.obtenerSociedades().subscribe(
      data => {
        this.sociedades = data.sapSociedad;
        this.sociedadesBase = data.sapSociedad;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );
  }

  restaFechas(f1, f2) {
    var aFecha1 = f1.split('/');
    var aFecha2 = f2.split('/');
    var fFecha1 = Date.UTC(aFecha1[2], aFecha1[1] - 1, aFecha1[0]);
    var fFecha2 = Date.UTC(aFecha2[2], aFecha2[1] - 1, aFecha2[0]);
    var dif = fFecha2 - fFecha1;
    this.diasTranscurridos = Math.floor(dif / (1000 * 60 * 60 * 24));
    return this.diasTranscurridos;
  }
  sinFechaI = false;
  sinFechaF = false;
  sinProv = false
  getFacturas() {
    this.busyBusqueda = true;
    let flagVerFacturas = false;
    let proveedor;
    if (this.rol === 2) {
      proveedor = this.proveedorFilter;
    } else {
      proveedor = this.user.id;
    }

    if (proveedor === undefined || proveedor === null) {
      proveedor = '';
    }

    const fechaI = (<HTMLInputElement>document.getElementById('fechai')).value;
    const fechaF = (<HTMLInputElement>document.getElementById('fechaf')).value;

    if (this.rol === 2) {
      if (proveedor === '' || fechaI === '' || fechaF === '') {
        if (fechaI === '') {
          this.sinFechaI = true;
        }else{
          this.sinFechaI = false;
        }
        if (fechaF === '') {
          this.sinFechaF = true;
        }else{
          this.sinFechaF = false;
        }
        if (proveedor === '') {
          this.sinProv = true;
        }else{
          this.sinProv = false;
        }
        flagVerFacturas = false;
      } else {
        this.sinProv = false;
        this.sinFechaF = false;
        this.sinFechaI = false;
        if (fechaI <= fechaF) {

          var d = new Date(fechaI);
          var d2 = new Date(fechaF);

          var r = d.getDate();
          var r2 = d.getMonth() + 1;
          var r3 = d.getFullYear();

          var ff = d2.getDate();
          var ff2 = d2.getMonth() + 1;
          var ff3 = d2.getFullYear();


          var f1 = r + '/' + r2 + '/' + r3;
          var f2 = ff + '/' + ff2 + '/' + ff3;

          this.restaFechas(f1, f2);

          if (this.diasTranscurridos > 90) {
            this.toasterService.pop('error', 'ERROR', this.toast90dias);
          } else {
            flagVerFacturas = true;
          }

        } else {
          this.toasterService.pop('error', 'ERROR', this.toastRangoFechasValido);
        }
      }
    } else {
      if (fechaI === '' || fechaF === '') {
        if (fechaI === '') {
          this.sinFechaI = true;
        }else{
          this.sinFechaI = false;
        }
        if (fechaF === '') {
          this.sinFechaF = true;
        }else{
          this.sinFechaF = false;
        }
        flagVerFacturas = false;
      } else {
        this.sinProv = false;
        this.sinFechaF = false;
        this.sinFechaI = false;
        if (fechaI <= fechaF) {

          var d = new Date(fechaI);
          var d2 = new Date(fechaF);

          var r = d.getDate();
          var r2 = d.getMonth() + 1;
          var r3 = d.getFullYear();

          var ff = d2.getDate();
          var ff2 = d2.getMonth() + 1;
          var ff3 = d2.getFullYear();


          var f1 = r + '/' + r2 + '/' + r3;
          var f2 = ff + '/' + ff2 + '/' + ff3;

          this.restaFechas(f1, f2);

          if (this.diasTranscurridos > 90) {
            this.toasterService.pop('error', 'ERROR', this.toast90dias);
          } else {
            flagVerFacturas = true;
          }


        } else {
          this.toasterService.pop('error', 'ERROR', this.toastRangoFechasValido);
        }
      }
    }

    this.fechaInicial = fechaI;
    this.fechaFinal = fechaF;

    if (flagVerFacturas) {
      this.accountStatus.obtenerFacturas(proveedor, this.folioi, this.foliof, this.serie, this.sociedad, this.pedido,
        this.doc_contable, fechaI, fechaF).subscribe(
          data => {
            this.busyBusqueda = false;
            if (data != null) {
              this.facturas = data.estadoCtaProveedor;
              let lang = localStorage.getItem("LOCAL_STORAGE")
              if (lang)
                lang = lang.replace(/["']/g, "")

              this.facturas.forEach(element => {
                for (const key in element) {
                  if (element.hasOwnProperty(key)) {
                    let elementObj = element[key];

                    if (lang === "en") {
                      switch (elementObj) {
                        case "Pagada Extranjero":
                          element.STATUS = "Paid Foreign"
                          break;
                        case "Cerrado sin complemento":
                          element.STATUS = "Closed without complement"
                          break;                          
                        case "Con complemento":
                          element.STATUS = "With complement"
                          break;
                        case "Pagada":
                          element.STATUS = "Paid"
                          break;
                        case "Parcial con complemento":
                          element.STATUS = "Partial with complement"
                          break;
                        case "Cancelado":
                          element.STATUS = "Cancelled"
                          break;
                        case "Cerrado con complementos parciales":
                          element.STATUS = "Closed with partial complements"
                          break;
                        case "Programada para pago":
                          element.STATUS = "Scheduled for payment"
                          break;                        
                        case "Factoraje":
                          element.STATUS = "Factoring"
                          break;
                        case "Nota Compensada":
                          element.STATUS = "Note compensated"
                          break;
                        case "En revisión":
                          element.STATUS = "In Review"
                          break;
                        case "Anulada":
                          element.STATUS = "Annuled"
                          break;
                        case "Procesada":
                          element.STATUS = "Processed"
                          break;
                        default:
                          break;
                      }
                    }

                    if (elementObj == 'Cancelado') element.STATUS = element.STATUS + ' / ' + element.MOTIVO_CANCELADO;
                  }
                }
              });
              
              this.rows = this.facturas;
              if (this.facturas.length > 0) {
                this.mostarxml = true;
              } else {
                this.mostarxml = false;
              }
            }

          },
          err => {
            this.busyBusqueda = false;
            if (err.status === 401) {
              this.storageService.openLogout();
            } 
          },
      );
    } else {
      this.busyBusqueda = false;
      if (this.rol == 2) {
        if (proveedor === '' || fechaI === '' || fechaF === '') {
          this.toasterService.pop('error', 'ERROR', this.toastCamposObligatorios);
        }
      } else {
        if (fechaI === '' || fechaF === '') {
          this.toasterService.pop('error', 'ERROR', this.toastMessage);
        }
      }

    }
  }

  getExcel() {
    var proveedor;

    if (this.rol === 2) {
      proveedor = this.proveedorFilter;
    } else {
      proveedor = this.user.id;
    }

    const params = '?proveedor=' + proveedor + '&folioi=' + this.folioi +
      '&foliof=' + this.foliof + '&serie=' + this.serie + '&sociedad=' + this.sociedad + '&pedido=' + this.pedido +
      '&doc_contable=' + this.doc_contable + '&fechai=' + this.fechaInicial + '&fechaf=' + this.fechaFinal;

    this.loadingExcel = true;

    this.accountStatus.downloadExcelReport(params).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'reporte-estado-cuenta.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        console.error('Error al descargar el reporte:', error);
      },
      () => {
        this.loadingExcel = false;
      }
    );
  }

  descargarPdf(index) {
    const docPdf = this.facturas[index].pdf;
    const srcFile = docPdf;
    const urlPdf = this.basePath + 'master-factura/obtener-pdf';

    if (srcFile) {
      const srcB64 = btoa(srcFile);

      const win = window.open(urlPdf + '?ruta=' + srcB64, '_blank');
      if (win) {
        win.focus();
      } else {
        alert('Por favor activa los popups en tu navegador');
      }
    } else {
      // console.log('El registro no contiene archivo PDF.');
    }
  }


  descargarXml(index) {
    const docXml = this.facturas[index].xml;
    const srcFile = docXml;
    const urlXml = this.basePath + 'master-factura/obtener-xml';

    if (srcFile) {
      const srcB64 = btoa(srcFile);

      const win = window.open(urlXml + '?ruta=' + srcB64, '_blank');
      if (win) {
        win.focus();
      } else {
        alert('Por favor activa los popups en tu navegador');
      }
    } else {
      // console.log('El registro no contiene archivo XML.');
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/account-status/account-status.component.ts